'use strict';
/**
 * @ngdoc function
 * @name thothAppApp.directive:project-estimated
 * @description
 * # project-list
 * Directive to generate a project index
 */
angular.module('thothApp.directives')
.directive('projectEstimated', function() {
  return {
    restrict: 'E',
    scope: {
      canExtend: '=',
      display: '='
    },
    templateUrl: 'views/projects/_estimated.html',
    controller: ['$scope', '$rootScope', '$state', 'EstimatedHours', 'EmployeePosition', 'Pagination', '$mdDialog',
    'SessionStorage', 'toaster',
    function ($scope, $rootScope, $state, EstimatedHours, EmployeePosition, Pagination, $mdDialog, SessionStorage,
      toaster) {
        $scope.estimatedHours = [];
        $scope.employeePositions = [];
        $scope.projectId = $state.params.projectId;
        $scope.estimatedHourHash = {
          'estimated_work_hour': {},
          'employee_position_list': [],
          'title': ''
        };
        $scope.estimatedHoursCount = 0;

        $scope.search = {
          'search': '',
          'by_column': '',
          'pager': {
            'currentPage': 1
          },
          'filters': {
            'id': 'fa-sort-asc',
            'employee_name': 'fa-sort',
            'employee_position': 'fa-sort',
            'estimated_hours': 'fa-sort'
          }
        };

        $scope.clearSearch = function() {
          $scope.search.search = '';
          $scope.search.by_column = '';
          $scope.search.pager.currentPage = 1;
          $scope.search.filters = {
            'estimated_code': 'fa-sort-asc',
            'employee_name': 'fa-sort',
            'employee_position': 'fa-sort',
            'estimated_hours': 'fa-sort'
          };

          $scope.getPage($scope.search.pager.currentPage);
        };

        $scope.filter = function(column) {
          var order = '';
          angular.forEach($scope.search.filters, function(value, key) {
            if(column === key) {
              if($scope.search.filters[key] === 'fa-sort-desc') {
                $scope.search.filters[key] = 'fa-sort-asc';
                order = 'ASC';
              } else {
                $scope.search.filters[key] = 'fa-sort-desc';
                order = 'DESC';
              }
            } else {
              $scope.search.filters[key] = 'fa-sort';
            }
          });
          $scope.search.by_column = {
            column: column,
            order: order
          };
          $scope.getPage(1);
        };

        $scope.newEstimatedHours = () => {
          $scope.estimatedHourHash.title = 'Estimación de horas';
          $scope.estimatedHourHash.employee_position_list = $scope.employeePositions;
          var currentScrollPosition = window.scrollY;
          $mdDialog.show({
            controller: $rootScope.EstimatedHoursCtrl,
            templateUrl: 'views/estimated_hours_dialog.html',
            scope: $scope,
            preserveScope: true,
            onRemoving: function() {
              window.scrollTo(0, currentScrollPosition);
            }
          }).then(function(result) {
            if (result.estimated_hours !== '' && result.employee_position_name !== '') {
              $scope.estimatedHourHash.estimated_work_hour = {
                estimated_hours: result.estimated_hours,
                project_id: $scope.projectId,
                employee_position: result.employee_position_name
              };
              EstimatedHours.save($scope.estimatedHourHash).then(function() {
                $scope.getPage($scope.search.pager.currentPage);
                toaster.pop('success', 'Estimación de horas', 'Se ha creado una nueva estimación de horas');
              }, function(error) {
                EstimatedHours.error(error);
                toaster.pop('error', 'Estimación de horas', 'No se ha podido crear una nueva estimación de horas');
              });
            } else {
              toaster.pop('error', 'Estimación de horas', 'Rellene todos los campos');
            }
          });
        };

        $scope.getPage = (page, optionalParams) => {
          var search = $scope.search.search;
          var params = optionalParams || {
            params: {
              page: page,
              per_page: 10,
              search: search,
              by_column: $scope.search.by_column,
              by_project: $scope.projectId
            }
          };

          EstimatedHours.index(params).then(function(response) {
            $scope.estimatedHours = response.data.estimated_hours;
            $scope.search.pager = Pagination.GetPager(
              response.data.meta.pagination.total_objects,
              page,
              response.data.meta.pagination.per_page
            );
            $rootScope.projectHash.estimatedHourCount = response.data.meta.pagination.total_objects;
          }, function(error) {
            EstimatedHours.error(error);
          });

          EmployeePosition.index({ params: { by_status: 'true', per_page: 50 } }).then(function(response) {
            $scope.employeePositions = response.data.employee_position;
          }, function(error) {
            EmployeePosition.error(error);
          });
        };

        $scope.destroyEstimatedHour = (estimatedHour) => {
          var confirm = $mdDialog.confirm()
            .title('Estimación de horas')
            .textContent('¿Está seguro que desea eliminar la estimación de horas?')
            .ariaLabel('Estimación de horas')
            .ok('Aceptar')
            .cancel('Cancelar');

          $mdDialog.show(confirm).then(function() {
            EstimatedHours.delete(estimatedHour.id).then(function() {
              toaster.pop('success', 'Estimación de horas', 'Se ha eliminado la estimación de horas');
              $scope.getPage($scope.search.pager.currentPage);
            }, function(error) {
              EstimatedHours.error(error);
            });
          });
        };

        $scope.getPage($scope.search.pager.currentPage);
    }]
  };
});
